// extracted by mini-css-extract-plugin
export default {"container":"WaitingPage_container__Trop3","titleText":"WaitingPage_titleText__jY21Q","mainText":"WaitingPage_mainText__ULNDX"};